<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddShortPlayProjectFlag" size="50%"
      :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="项目名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入项目名称" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="关联小说" :label-width="formLabelWidth">
                <SelectChecked :options="movieOptions" placeholder="请选择关联小说" :isRemoveAllTag="isRemoveAllTag"
                  @selectedVal="selectedReferral" style="width: 85%;" />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="项目简介" :label-width="formLabelWidth">
                <el-input v-model="addFrom.project_info" placeholder="请输入项目简介" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合作类型" :label-width="formLabelWidth" style="width: 85%;" prop="cooperate_type">
                <el-radio-group v-model="addFrom.cooperate_type">
                  <el-radio :label="0">自制</el-radio>
                  <el-radio :label="1">引入</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="立项时间" prop="project_time" :label-width="formLabelWidth">

                <el-date-picker v-model="addFrom.project_time" type="date" placeholder="选择立项时间" align="right"
                  value-format="yyyy-MM-dd" style="width: 85%;" :picker-options="pickerOptions">
                </el-date-picker>

              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="交付时间" :label-width="formLabelWidth" prop="deliver_time">
                <el-date-picker v-model="addFrom.deliver_time" type="date" style="width: 85%;" 
                  placeholder="选择交付时间" align="right" value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="评级" prop="level" :label-width="formLabelWidth">
                <el-select v-model="addFrom.level" placeholder="请选择评级" clearable style="width: 85%;">
                  <el-option label="S" :value="1"></el-option>
                  <el-option label="A+" :value="2"></el-option>
                  <el-option label="A" :value="3"></el-option>
                  <el-option label="B" :value="4"></el-option>
                  <el-option label="C" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb40">
              <el-form-item label="排期时间" prop="time" :label-width="formLabelWidth">
                <el-row :gutter="36">
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36" class="mb20">
                    <el-form-item label="IAP" prop="iap_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.iap_time"
                        style="width: 84%;"
                        type="datetime"
                        placeholder="请选择 IAP 排期时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36" class="mb20">
                    <el-form-item label="IAA" prop="iaa_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.iaa_time"
                        style="width: 84%;"
                        type="datetime"
                        placeholder="请选择 IAA 排期时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36">
                    <el-form-item label="星图" prop="starmap_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.starmap_time"
                        style="width: 84%;"
                        type="datetime"
                        placeholder="请选择 星图 排期时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" style="margin-top: 20px;">
              <el-form-item label="推荐卡点" prop="stuck_point" :label-width="formLabelWidth">
                <el-input v-model="addFrom.stuck_point" placeholder="请输入推荐卡点" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="网盘链接" prop="cloud_url" :label-width="formLabelWidth">
                <el-input v-model="addFrom.cloud_url" placeholder="请输入网盘链接" clearable style="width: 85%;">
                  <template slot="append"><span style="cursor: pointer" @click="copy()">复制</span></template>
                </el-input>
              </el-form-item>
            </el-col>
            
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="版权主体" :label-width="formLabelWidth" prop="copyright_id">
                <div style="display: flex;">
                <el-select v-model="addFrom.subject_id_bq" placeholder="请选择版权主体" filterable clearable
                  style="width: 85%;">
                  <el-option v-for="dict in subjectBqList" :key="dict.id" :label="dict.name" :value="dict.id" />
                </el-select>
                <img @click="AddPushSubjec"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="getSubjectSelectByType({subjectBqList:1})"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="承制主体" :label-width="formLabelWidth" prop="copyright_id">
                <div style="display: flex;">
                <el-select v-model="addFrom.subject_id_cz" placeholder="请选择承制主体" filterable clearable
                  style="width: 85%;">
                  <el-option v-for="dict in subjectCzList" :key="dict.id" :label="dict.name" :value="dict.id" />
                </el-select>
                <img @click="AddPushSubjec"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="getSubjectSelectByType({subjectBqList:2})"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="发行主体" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <SelectChecked :options="subjectFxOptions" placeholder="请选择发行主体" :isRemoveAllTag="isRemoveAllTagFx"
                  @selectedVal="selectedSubjectFx" style="width: 85%;" />
                   <img @click="AddPushSubjec"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="getSubjectFxSelect()"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>

            </el-col>
            
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="剧本主体" :label-width="formLabelWidth" prop="copyright_id">
                <div style="display: flex;">
                <el-select v-model="addFrom.subject_id_jb" placeholder="请选择剧本主体" filterable clearable
                  style="width: 85%;">
                  <el-option v-for="dict in subjectJbList" :key="dict.id" :label="dict.name" :value="dict.id" />
                </el-select>
                <img @click="AddPushSubjec"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="getSubjectSelectByType({subjectBqList:9})"
                   style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="所属团队" :label-width="formLabelWidth" prop="copyright_id">
                <el-select v-model="addFrom.team_id" placeholder="请选择所属团队" filterable clearable
                  style="width: 85%;">
                  <el-option v-for="dict in teamList" :key="dict.id" :label="dict.name" :value="dict.id" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>

  </div>
</template>

<script>
import { MoneyManagementAPI } from '@/api/MoneyManagement/MoneyManagement';
import { GeneralCollectApi } from '@/api/statistics/comStatistics/index';
import { processErrors } from "@/utils/errorHandler";
import SelectChecked from '@/components/Select/SelectChecked'
export default {
  props: ['AddShortPlayProjectFlag', "editID"],
  components: {
    SelectChecked,

  },
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      formLabelWidthChild: "50px",
      addFrom: {
        deliver_time: '',
        cooperate_type: 0,
        subject_id_cz: '',
        subject_id_bq: '',
        subject_id_jb: '',
        subject_id_fx: '',
        movie_id: '',
        project_time: this.getCurrentTime(),
        project_info: "",
        name: "",
        status: 1,
        id: "",
        team_id:'',
        level:'',
        iap_time:'',
        iaa_time:'',
        starmap_time:'',
        stuck_point:'',
        cloud_url:''
      },
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
        ],
        project_time: [
          { required: true, message: '请选择立项时间', trigger: 'change' },
        ],
        deliver_time: [
          { required: true, message: '请选择交付时间', trigger: 'change' },
        ],
        cooperate_type: [
          { required: true, message: '请选择合作类型', trigger: 'change' },
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ],
      },
      isRemoveAllTag: 0,
      isRemoveAllTagFx: 0,
      movieOptions: [],
      subjectFxOptions: [],

      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      subjectCzList: [],
      subjectBqList: [],
      subjectJbList: [],
      AddSubjectFlag: false,
      TitleOne: "",
      teamList:[],
    };
  },
  created() {
    this.getSubjectSelectByType();
  },
  methods: {
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    /**
     * 单选下拉框
     * 获取对应主体类型的主体列表
     * @param { Object } singleType 需要单独请求的主体信息，
     *                            键名：list名字，key值：对应的id
     *                            如： {subjectBqList: 1} 
     * 示例调用：
     * - 请求编辑所需所有单选主体列表（即 请求initPost）
     * getSubjectList()
     * - 单独请求一个
     * getSubjectList({ listName: 'subjectBqList', id: 1 });
     */
    getSubjectSelectByType(singleType) {
      let api = MoneyManagementAPI()
      
      // 需要获取的主体类型及对应的 list属性名
      const initPost = {
        subjectBqList: 1,
        subjectCzList: 2,
        subjectJbList: 9,
      }
      let subList = singleType ? singleType : initPost
      // 遍历请求
      for (let type in subList){
        let params = {
          cooperate_type: subList[type]
        }
        api.getSubjectSelect(params).then(res => {
          if (res.code == 0) {
            this[type] = res.data
          } else {
            processErrors(res);
          }
        })
      }
    },

    getSubjectFxSelect() {
      const api = MoneyManagementAPI();
      let params = {
        cooperate_type: 4,
      };
      api.getSubjectSelect(params)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.subjectFxOptions = data.map(item => ({
              value: item.id.toString(),
              label: item.name,
              check: false
            }));
            if (this.addFrom.subject_id_fx) {
              this.subjectFxOptions = this.subjectFxOptions.map(item => {
                return {
                  ...item,
                  check: this.addFrom.subject_id_fx.split(',').includes(item.value)
                };
              });
            }
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    handleClose(done) {
      this.isRemoveAllTag += 1;
      this.isRemoveAllTagFx += 1;
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },
    // 获取团队列表
    getTeamSelectList(){
      let api = MoneyManagementAPI()
      api.getTeamSelect().then(res=>{
        this.teamList = res.data
      })
    },

    getSelectMovie() {
      const api = MoneyManagementAPI();
      let params = {
        id: this.editID
      };
      api.moviesSelect(params)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.movieOptions = data.map(item => ({
              value: item.id.toString(),
              label: item.name,
              check: false
            }));
            if (this.addFrom.movie_id) {
              this.movieOptions = this.movieOptions.map(item => {
                return {
                  ...item,
                  check: this.addFrom.movie_id.split(',').includes(item.value)
                };
              });
            }
          } else {
            processErrors(res);
          }
        })
        .catch((error) => {
        });
    },

    selectedReferral(value) {
      this.addFrom.movie_id = value.join(',');
    },

    selectedSubjectFx(value) {
      this.addFrom.subject_id_fx = value.join(',');
    },

    AddNone() {
      this.addFrom = {
        deliver_time: '',
        cooperate_type: 0,
        subject_id_cz: '',
        subject_id_bq: '',
        subject_id_jb: '',
        subject_id_fx: '',
        movie_id: '',
        project_time: this.getCurrentTime(),
        project_info: "",
        name: "",
        status: 1,
        id: "",
        team_id:'',
        level:'',
        iap_time:'',
        iaa_time:'',
        starmap_time:'',
        stuck_point:'',
        cloud_url:''
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let createText = ''
          if (this.addFrom.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }
          delete this.addFrom.team_name;
          let api = MoneyManagementAPI()
          api.shortPlayProjectAdded(this.addFrom).then(res => {
            if (res.code == 0) {
              this.isRemoveAllTag += 1;
              this.isRemoveAllTagFx += 1;
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    },
    AddPushSubjec() {
        const baseExportUrl = new URL(window.location.href).origin;
        let url = baseExportUrl + '/#/MoneyManagement/subject';
        window.open(url);
    },
    copy(){
      if (this.addFrom.cloud_url) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(this.addFrom.cloud_url)
            .then(() => {
              // 复制成功
              this.$message.success('复制成功！');
            })
            .catch((err) => {
              // 复制失败
              this.$message.error('复制失败！');
            });
        } else {
          // 浏览器不支持剪贴板API
          this.$message.error('当前浏览器不支持复制到剪贴板功能！');
        }
      }else{
        this.$message.warning('当前没有链接可复制');
      }
    },
  },

  mounted() {
    if (this.editID != "") {
      let api = MoneyManagementAPI()
      api.shortPlayProjectInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = res.data
          // 初始化团队id
          res.data.team_id == 0 ? this.addFrom.team_id = '' : ''
          res.data.level == 0 ? this.addFrom.level = '' : ''
          res.data.subject_id_cz == 0 ? this.addFrom.subject_id_cz = '' : ''
          res.data.subject_id_bq == 0 ? this.addFrom.subject_id_bq = '' : ''
          res.data.subject_id_jb == 0 ? this.addFrom.subject_id_jb = '' : ''
          this.getTeamSelectList()
          this.getSelectMovie();
          this.getSubjectFxSelect();
        } else {
          processErrors(res);
        }
      })
    } else {
      this.getTeamSelectList()
      this.getSelectMovie();
      this.getSubjectFxSelect();
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px);
  /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto;
  /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px;
  /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>